import React from "react";
import "./AuthPasswordReset.css";
import { Row, Col, Card, Form, Input, Button, Icon, Typography } from "antd";
import { AuthPasswordResetProps } from "./Types";
import { nameofFactory } from "../../../utils";
import { UserPasswordReset } from "../../../store/passwordReset";
import { Trans } from "@lingui/macro";

const AuthPasswordReset: React.FC<AuthPasswordResetProps> = (props) => {
  const { form, onPasswordReset, userPasswordResetState } = props;
  const nameof = nameofFactory<UserPasswordReset>();
  const { getFieldDecorator, validateFields } = form;

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();

    validateFields((err, values) => {
      if (!err) {
        onPasswordReset(values);
      }
    });
  };

  return (
    <Row type="flex" className="passwordReset-container">
      <Card
        title={<CardTitle />}
        className="passwordReset-card"
        bordered={false}
      >
        <Row type="flex" justify="center">
          <Col span={6}>
            <Form colon={false} onSubmit={handleSubmit}>
              <Form.Item
                label={<Trans id="PasswordReset.EmailLabel">Email</Trans>}
              >
                {getFieldDecorator(nameof("Email"), {
                  rules: [
                    {
                      required: true,
                      message: (
                        <Trans id="PasswordReset.EmailRequiredError">
                          The email field is required
                        </Trans>
                      ),
                    },
                    {
                      type: "email",
                      message: (
                        <Trans id="PasswordReset.EmailInvalidError">
                          Please enter a valid email
                        </Trans>
                      ),
                    },
                  ],
                })(
                  <Input
                    prefix={<Icon type="user" />}
                    size="large"
                    type="email"
                    //   disabled={userPasswordResetState.loading}
                  />
                )}
              </Form.Item>
              <Row type="flex" justify="end">
                <Button
                  size="large"
                  type="primary"
                  htmlType="submit"
                  loading={userPasswordResetState.loading}
                  className="passwordReset-button"
                >
                  <Trans render="span" id="PasswordReset.RecoverButtonLabel">
                    Go
                  </Trans>
                  <Icon type="arrow-right" />
                </Button>
              </Row>
            </Form>
          </Col>
        </Row>
      </Card>
    </Row>
  );
};

const CardTitle: React.FC = () => (
  <Row type="flex" justify="center" align="middle">
    <Typography.Text strong>
      <Trans render="h3" id="PasswordReset.Title">
        Password reset
      </Trans>
    </Typography.Text>
  </Row>
);

export default Form.create<AuthPasswordResetProps>()(AuthPasswordReset);
